/* eslint-disable */
export default {
    billing_all_projects: "Alle projecten",
    billing_select_organisation_first: "Selecteer eerst een organisatie of datumbereik",
    billing_no_results: "Geen resultaten",
    billing_table_organisation: "Organisatie",
    billing_table_project: "Project",
    billing_table_name: "Naam",
    billing_table_email: "E-mail",
    billing_table_completion_date: "Afgerond",
    billing_table_product_name: "Product",
    billing_table_title: "Facturatie",
    billing_export: "Exporteer",
    billing_all_products: "Alle producten",
    billing_general_error: "Er is een fout opgetreden. Probeer het opnieuw.",
    billing_fetching_results: "Resultaten worden opgehaald, even geduld",
    billing_selected: "geselecteerd",
    billing_mark_as_billed_confirm_title: "Markeer deelnemers als gefactureerd",
    billing_mark_as_billed_confirm: "Bevestigen",
    billing_mark_as_billed_cancel: "Annuleren",
    billing_mark_as_billed_modal_text_a: "facturen zullen worden gemarkeerd als gefactureerd.",
    billing_mark_as_billed_modal_text_b: "De factureringsdatum is",
    billing_mark_as_billed_modal_text_c: "Weet u zeker dat u deze facturen wilt factureren?",
    billing_mark_as_billed_general_error: "Er is iets misgegaan bij het markeren van deelnemers als gefactureerd. Probeer het later opnieuw.",
    billing_mark_as_billed_success: "De geselecteerde deelnemers zijn gemarkeerd als gefactureerd.",
    billing_mark_as_unbilled_general_error: "Er is iets misgegaan bij het markeren van deelnemers als ongefactureerd. Probeer het later opnieuw.",
    billing_mark_as_unbilled_success: "De geselecteerde deelnemers zijn gemarkeerd als ongefactureerd.",
    billing_set_participants_billing_state_confirm: "Bevestigen",
    billing_set_participants_billing_state_cancel: "Annuleren",
    billing_set_participants_billing_state_show_billed: "Toon gefactureerd",
    billing_set_participants_billing_state_billed_date: "Gefactureerd",
    billing_set_participants_billing_state_mark_as_billed: "Markeer als gefactureerd",
    billing_set_participants_billing_state_mark_as_unbilled: "Markeer als ongefactureerd",
    billing_mark_as_unbilled_title: "Reset factuurdatum",
    billing_mark_as_billed_title: "Markeer als gefactureerd",
    billing_mark_as_unbilled_modal_text_a: "De factureringsdatum van",
    billing_mark_as_unbilled_modal_text_c: "Weet u zeker dat u de factureringsdatum van deze facturen wilt resetten?",
    billing_mark_as_unbilled_modal_text_b: "facturen zal worden gereset.",
    billing_set_participants_billing_state_show_unbilled: "Toon ongefactureerd",
    billing_search_for_organisation: "Zoek naar organisatie",
    billing_set_participants_billing_state_show_demo: "Toon demo",
    billing_detail_panel_tab_cost_heading: "Kostenplaats",
    billing_cost_heading_success: "De kostenplaats is met succes aangepast.",
    billing_cost_heading_error: "Er ging iets mis bij het opslaan van de kostenplaats. Probeer het later opnieuw.",
    billing_cost_heading_title: "Kostenplaats",
    billing_cost_heading_save: "Opslaan",
    billing_finance_header: "LTP Prijzen",
    billing_finance_staffel_header: "Hieronder zie je alle prijzen voor LTP producten voor het geselecteerde jaar.",
    billing_finance_unit_header: "Hieronder zie je de prijzen voor LTP producten per afname.",
    billing_finance_no_pricing_available: "Geen prijsinformatie beschikbaar",
    billing_finance_table_product: "Product",
    billing_finance_table_per_unit: "Per afname",
    billing_finance_tab_participants: "Deelnemers",
    billing_finance_tab_pricing: "Prijzen",
    billing_finance_table_product_building_docks: "Building Docks",
    billing_finance_table_product_talent_fit: "Talent Fit",
    billing_finance_table_product_talent_navigator: "Talent Navigator",
    billing_finance_table_product_pre_fit: "Pre Fit",
    billing_finance_table_product_talent_scan: "Talent Scan",
    billing_detail_panel_tab_api: "API instellingen",
    billing_detail_panel_api_linked_to: "Deze organisatie is gelinkt aan AFAS project ",
    billing_finance_table_product_integrity: "Integriteit",
    billing_finance_table_product_dealing_with_resistance: "Omgaan met weerstand",
    billing_finance_table_product_work_safely: "Veilig werken",
    billing_finance_table_product_derailment: "Omgaan met druk",
    billing_table_addon_name: "Add-on",
    billing_error_invalid_date_range: "Ongeldige waarden voor datum ingevoerd, datumfilter niet toegepast",
    billing_finance_table_product_phase: "fase",
    billing_finance_table_product_multi_phase: "2-Phase Talent Fit",
    billing_finance_table_product_critical_thinking: "Kritisch redeneren",
    billing_finance_table_product_test_ned: "TestNed Scan",
    billing_finance_table_product_test_ned_periodic: "TestNed Scan Periodiek",
    billing_set_participants_billing_state_added_by: "Aangemaakt door",
    billing_table_price: "Totaal prijs",
    billing_finance_table_product_team_and_organisation: "Team & Organisation",
    billing_finance_table_product_compact: "Compact (hybrid)",
    billing_finance_table_product_basic: "Zilver",
    billing_finance_table_product_regular: "Extensive assessment (goud)",
    billing_finance_table_product_premium: "Premium assessment (platinum)",
    billing_finance_table_product_c_level: "Executive Assessment",
    billing_finance_table_product_executive: "Compact Executive Assessment",
    billing_finance_table_product_periodic_assessment_test_ned: "Periodieke keuring (TestNed)",
    billing_finance_table_product_indication_assessment_test_ned: "Indicatiekeuring (TestNed)",
    billing_finance_table_product_safety: "Safety",
    billing_finance_table_product_employment_assessment_test_ned: "Aanstellingskeuring",
    billing_set_filter_participants_button_label: "Deelnemers filteren",
    billing_finance_table_product_no_online_scan: "Zonder online scan",
    billing_table_item: "Item",
    billing_detail_panel_tab_finance_details: "Financiële details",
    billing_detail_panel_tab_finance_details_no_afas_id: "Nog geen id beschikbaar",
    billing_detail_panel_price_details_title: "Prijsdetails",
    billing_detail_panel_price_details_table_column_item: "Item",
    billing_detail_panel_price_details_table_column_price: "Prijs",
    billing_detail_panel_price_details_table_column_reason: "Reden",
    billing_detail_panel_price_details_table_column_price_type: "Prijstype",
    billing_finance_table_product_executive_scan: "Executive Scan",
    billing_detail_panel_price_details_table_price_type_global_price: "Standaard",
    billing_detail_panel_price_details_table_price_type_org_price: "Organisatie",
    billing_detail_panel_price_details_table_price_type_license: "Licentie",
    billing_finance_tab_invoices: "Facturen",
    billing_set_filter_invoices_button_label: "Facturen filteren",
    billing_detail_panel_price_details_table_reason_charge: "Factureren",
    billing_detail_panel_price_details_table_reason_cancellation: "Annulering",
    billing_detail_panel_price_details_table_reason_reservation: "Reservering",
    billing_detail_panel_tab_more: "Meer",
    billing_afas_id_title: "AFAS id",
    billing_afas_project_title: "AFAS project ",
    billing_log_title: "Log",
    billing_participant_files_title: "Deelnemersbestanden"
};
